import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../../api/ApiClient";
import { Device } from "../data/Device";
import { AxiosError } from "axios";

type CreateDeviceInput = Omit<Device, 'lifeTime' | 'id'>;

async function post(data: CreateDeviceInput): Promise<Device> {
    try {
        const response = await ApiClient({ url: "/devices", method: "POST", data });
        console.log(response.status)
        if (response.status === 201) {
            return response.data;
        }
        throw new Error(response.data);
    } catch (error) {
        throw new Error(error instanceof AxiosError ? error.response?.data?.error : "An unexpected error occurred");
    }
}

export function usePostDeviceMutation(onSuccess: (data: Device) => void, onError: (error: Error) => void) {
    return useMutation<Device, Error, CreateDeviceInput>({
        mutationKey: ["post-device"],
        mutationFn: post,
        onSuccess: onSuccess,
        onError: onError
    });
}